import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/pages/HowToUse.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        }, {
          path: '/howtouse',
          name: 'howtouse',
          component: () => import('./views/pages/HowToUse.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/datahub',
          name: 'datahub',
          component: () => import('./views/pages/MyData.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/campaigns',
          name: 'campaigns',
          component: () => import('./views/pages/Campaigns.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/payment',
          name: 'payment',
          component: () => import('@/views/pages/Payment/Payment.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/producteditor',
          name: 'producteditor',
          component: () => import('./views/pages/ProductEditor/ProductEditor.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/rewardmanager',
          name: 'rewardmanager',
          component: () => import('./views/pages/RewardManager/RewardManager.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/taskmanager',
          name: 'taskmanager',
          component: () => import('./views/pages/TaskManager/TaskManager.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/create-campaign',
          name: 'create-campaign',
          component: () => import('./views/pages/CreateCampaign/CreateCampaign.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/edit-campaign/:id',
          name: 'edit-campaign',
          component: () => import('./views/pages/CreateCampaign/CreateCampaign.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/edit-user/:id',
          name: 'edit-user',
          component: () => import('./views/EditUserSettings.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/connections',
          name: 'connections',
          component: () => import('./views/pages/Connections.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/users',
          name: 'users',
          component: () => import('./views/pages/Users.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/account',
          name: 'account',
          component: () => import('./views/Settings.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/billing',
          name: 'billing',
          component: () => import('./views/pages/Billing/Billing.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/billing/:tab',
          name: 'billingTab',
          component: () => import('./views/pages/Billing/Billing.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/help',
          name: 'help',
          component: () => import('./views/pages/Help.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/unsubscribe',
          name: 'unsubscribe',
          component: () => import('@/views/pages/Unsubscribe.vue')
        },
        {
          path: '/cart/:slug',
          name: 'cart',
          component: () => import('@/views/pages/Checkout/Cart.vue'),
          props: true
        }, /*
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/Register.vue')
        },*/
        {
          path: '/reset-password',
          name: 'reset-password',
          component: () => import('@/views/pages/ForgotPassword.vue')
        },
        {
          path: '/change-password/:passtoken',
          name: 'change-password',
          component: () => import('@/views/pages/ChangePassword.vue'),
          props: true
        },
        {
          path: '/initial-login/:passtoken',
          name: 'initial-login',
          component: () => import('@/views/pages/InitPassword.vue'),
          props: true
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/scratch/:slug',
          name: 'scratch',
          component: () => import('./views/CardViewForm.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/scratch/code/:slug',
          name: 'cardviewthanks',
          component: () => import('./views/CardViewThanks.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/scratch/game/:slug',
          name: 'cardviewscratch',
          component: () => import('./views/CardViewScratch.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          },
          props: true
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})


router.beforeEach(async (to, from, next) => {

  // If auth required, check login. If login fails redirect to login page
  //console.log(to)
  //console.log(from)
  //console.log(next)
  console.log(to)
  const isLoggedin = await store.state.isUserLoggedIn()
  const isCapable = await store.state.userCapable(store.state.AppActiveUser)

  if (to.name !== 'page-login' &&
    to.name !== 'initial-login' &&
    to.name !== 'scratch' &&
    to.name !== 'cart' &&
    to.name !== 'thankyou' &&
    to.name !== 'cardviewform' &&
    to.name !== 'cardviewthanks' &&
    to.name !== 'cardviewscratch' &&
    to.name !== 'page-register' &&
    to.name !== 'reset-password' &&
    to.name !== 'change-password' &&
    !isLoggedin) {

    if (to.fullPath !== '/') {
      next({name: 'page-login', query: {page: to.fullPath}})
    } else {
      next({name: 'page-login'})
    }
  } else if (to.name !== 'page-login' && isLoggedin) {
    console.log('logged in')
    if (!isCapable &&
      to.name !== 'connections' &&
      to.name !== 'edit-campaign' &&
      to.name !== 'datahub' &&
      to.name !== 'campaigns' &&
      to.name !== 'rewardmanager' &&
      to.name !== 'create-campaign' &&
      to.name !== 'home' &&
      to.name !== 'payment' &&
      to.name !== 'billing' &&
      to.name !== 'billingTab'
    ) {
      console.log('not capable')
      next({name: 'billingTab', params:{tab: 'make-payment'}})
    } else if (!isCapable && (to.name === 'home' || to.name === 'payment' || to.name === 'billing' || to.name === 'billingTab')) {
      console.log('capable')
      next()
    } else if (isCapable && to.name === 'payment') {
      console.log('capable')
      next({name: 'home'})
    } else if (isCapable) {
      console.log('capable')
      next()
    } else {
      console.log('404')
      next({ name: 'page-error-404' })
    }
  } else if (isLoggedin) {
    console.log('tqp', to.query.page)
    if (to.query.page) {
      next({path: to.query.page})
    } else {
      next({name: 'home'})
    }
  } else {
    next()
  }
})


export default router
